import routes from "./routes.json";
import fr from "./pages.fr";
import de from "./pages.de";
import es from "./pages.es";
import it from "./pages.it";
import nl from "./pages.nl";

export const ORIGIN = routes.origin;
export const LANGS = routes.langs;
export const DEFAULT_LANG = routes.defaultLang;
export const PAGES = routes.pages;

const CONTENT = { fr, de, es, it, nl };

export function pagePath(key, lang) {
  const p = PAGES.find((x) => x.key === key);
  if (!p) return "/";
  return p.paths[lang] || p.paths[DEFAULT_LANG];
}

export function pageUrl(key, lang) {
  const path = pagePath(key, lang);
  return ORIGIN + (path === "/" ? "/" : path);
}

/** hreflang réciproques + x-default (FR) pour une même page. */
export function alternatesFor(key) {
  const alts = LANGS.map((l) => ({ hreflang: l, href: pageUrl(key, l) }));
  alts.push({ hreflang: "x-default", href: pageUrl(key, DEFAULT_LANG) });
  return alts;
}

/** Contenu d'une page — fallback FR si une langue est incomplète. */
export function getPage(key, lang) {
  return CONTENT[lang]?.[key] || CONTENT[DEFAULT_LANG][key];
}

/** Toutes les routes SEO à déclarer dans le router / le prerender / le sitemap. */
export const SEO_ROUTES = PAGES.flatMap((p) =>
  LANGS.map((lang) => ({ key: p.key, lang, path: p.paths[lang], group: p.group, priority: p.priority }))
);

export function findRouteByPath(pathname) {
  const clean = pathname.length > 1 ? pathname.replace(/\/$/, "") : pathname;
  return SEO_ROUTES.find((r) => r.path === clean) || null;
}

/** Liens de maillage interne résolus dans la bonne langue. */
export function resolveLinks(links, lang) {
  return (links || []).map((l) => ({ to: pagePath(l.key, lang), label: l.label }));
}
